export default __webpack_public_path__ + "static/media/nextInactive.5f5dd643.svg";